import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Configuration } from '../../../app.constants';
import {AssociateService} from '../../services/associate.service';

@Component({
  selector: 'app-proxy-users-popup',
  templateUrl: './proxy-users-popup.component.html',
  styleUrls: ['./proxy-users-popup.component.css']
})
export class ProxyUsersPopupComponent implements OnInit {
  public search = '' ;
  public associates: any;
  public myProxyInfo: any;
  public serverApiUrl;

  constructor(public dialogRef: MatDialogRef<ProxyUsersPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public associateService: AssociateService,
    public config: Configuration) {}

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    this.myProxyInfo = {
      avatarUrl: this.data.associate.personalInformation.avatarUrl,
      associateId: this.data.associate._id,
      fullName: this.data.associate.personalInformation.fullName,
      email: this.data.associate.workContactDetails.workEmail,
      contactNumber: this.data.associate.workContactDetails.workMobile,
      company: this.data.associate.jobDescription.company.name,
      companyId: this.data.associate.jobDescription.company.id,
      jobTitle: this.data.associate.jobDescription ? this.data.associate.jobDescription.jobTitle : '',
      jobCategory: this.data.associate.jobDescription ? this.data.associate.jobDescription.jobCategory : '',
      localID: this.data.associate.localId,
      country: this.data.associate.workContactDetails ? this.data.associate.workContactDetails.workCountry : '',
    };
  }
  proceed() {
    this.dialogRef.close();
  }
  cancel() {
    this.dialogRef.close();
  }

  associateSearch() {
    this.associateService.getAllAssociatesFilter(this.search, '' , '').subscribe(data => {
      this.associates = data;
    })
  }

  removeProxy(index) {
    const proxy = this.data.associate.myProxyUsers.splice(index, 1)[0];
    this.associateService.getAssociate(proxy.associateId).subscribe(associate => {
      index = associate['data'][0]['applicableProxies'].map(function(e) { return e.associateId; }).indexOf(this.data.associate._id);
      associate['data'][0]['applicableProxies'].splice(index, 1);
      this.associateService.updateAssociate_(associate['data'][0]).subscribe();
    }, err => {
      console.log('error', err);
    })
  }

  addAssociate(associate) {
    this.search = '';
    this.associates = [];
    const proxy = {
      avatarUrl: associate.personalInformation.avatarUrl,
      associateId: associate._id,
      fullName: associate.personalInformation.fullName,
      email: associate.workContactDetails.workEmail,
      contactNumber: associate.workContactDetails.workMobile,
      company: associate.jobDescription.company.name,
      companyId: associate.jobDescription.company.id,
      jobTitle: associate.jobDescription ? associate.jobDescription.jobTitle : '',
      jobCategory: associate.jobDescription ? associate.jobDescription.jobCategory : '',
      localID: associate.localId,
      country: associate.workContactDetails ? associate.workContactDetails.workCountry : '',
    };

    // check if already exist
    if (this.data.associate.myProxyUsers) {
      let isExist = false;
      this.data.associate.myProxyUsers.forEach(pr => {
        if (pr.associateId === proxy.associateId) {
          isExist = true;
        }
      });
      // if already exist do nothing
      if (isExist) {
        return;
      }

      if (associate.applicableProxies) {
        associate.applicableProxies.unshift(this.myProxyInfo);
      }else {
        associate.applicableProxies = [this.myProxyInfo];
      }

      this.associateService.updateAssociate_(associate).subscribe(
        res=>{
          console.log(res)
        },
        err=>{
          console.log(err)
        });
      this.data.associate.myProxyUsers.unshift(proxy);
    } else {
      this.data.associate.myProxyUsers = [proxy];
    }

  }

}
